<template>
    <div>

        <smart-nav-maker
            :input="menu"
            endpoint="menu"
            :name="menu.name"
            :constants="constants"
            @refresh="refreshPreview()"
        />

    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import SmartNavMaker from "@/SmartNav/SmartNavMaker";

export default {
    name: "SmartNavShow",
    layout: (h, page) => {
        return h(AppLayout, [
            page
        ])
    },
    components: {
        SmartNavMaker
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'input': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            menu: this.input,
        }
    },
    methods: {
        refreshPreview() {
            this.$refs.preview?.fetchMenu(true)
        },
    },
}
</script>

<style>

</style>
